import { Routes, Route } from 'react-router-dom'
import Home from '../pages/Home'
import AboutUs from '../pages/AboutUs'
import PrivacyPolicy from '../pages/PrivacyPolicy'
import PageNotFound from '../pages/PageNotFound.tsx'
import BlogRoutes from './Blog'
import { useSiteData } from '../context/fetchContext'
import Services from '../pages/Services'
import Gallery from '../pages/Gallery'

const LandingRoutes = () => {
    const { gallery } = useSiteData()
    return (
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/services' element={<Services gallery={gallery} />} />
            {/* NOTE - This is for the gallery */}
            {gallery.map((data, i) => {
                const route = `/services/${data.slug}`
                return <Route key={i} path={route} element={<Gallery data={data} />} />
            })}
            <Route path='/Blog/*' element={<BlogRoutes />} />
            <Route path='/about-us' element={<AboutUs />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='*' element={<PageNotFound />} />
        </Routes>
    )
}

export default LandingRoutes